import { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface ScannerOverlayProps {
  onScan: (text: string) => void;
  onClose: () => void;
}

const ALL_FORMATS = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
];

export default function ScannerOverlay({ onScan, onClose }: ScannerOverlayProps) {
  const scannerRef = useRef<Html5Qrcode | null>(null);
  const [scannedText, setScannedText] = useState<string | null>(null);

  useEffect(() => {
    const scanner = new Html5Qrcode('scanner-container');
    scannerRef.current = scanner;

    let stopped = false;

    const onScanSuccess = async (decodedText: string) => {
      if (stopped) return;
      stopped = true;
      // Stop scanner FIRST (wait for it), THEN fire onScan
      try {
        await scanner.stop();
      } catch {}
      if (!stopped) return;
      // Store scanned text - separate effect will handle the callback
      setScannedText(decodedText);
    };

    scanner.start(
      { facingMode: 'environment' },
      { fps: 20, qrbox: { width: 260, height: 200 }, formatsToSupport: ALL_FORMATS },
      onScanSuccess,
      () => {}
    ).catch(() => {});

    return () => {
      stopped = true;
      scanner.stop().catch(() => {});
    };
  }, []);

  // Fire onScan in a separate effect AFTER scanner is fully stopped
  useEffect(() => {
    if (scannedText !== null) {
      onScan(scannedText);
    }
  }, [scannedText, onScan]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="font-semibold text-gray-900">Code scannen</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none">&times;</button>
        </div>
        <div
          id="scanner-container"
          style={{ width: '100%', aspectRatio: '1', background: '#000' }}
        />
        <p className="text-xs text-gray-500 text-center py-3">
          QR-Code oder Barcode vor die Kamera halten — automatische Erkennung
        </p>
      </div>
    </div>
  );
}